/* Compra por paquete de los gabinetes LED sueltos (José, 13-10). Lógica del snippet fs-led-paquete:
   · flight case de 5/6 = variante del producto pack (precio de Shopify, el que cobra el checkout);
   · procesador preseleccionado como calc.php: el primero con carga ≤ 80 %; si ninguno, el mayor que quepa;
   · accesorios: cantidad elegida por el cliente, con sugerido (módulos 7 %, mín. 5; Powercon 1 cada 8; repuestos 1);
   · al enviar el formulario de compra (botón de la tarjeta o barra móvil) se añaden al carrito todas las líneas. */
(function () {
  if (window.__fsPk) return; window.__fsPk = 1;
  var el = document.getElementById('fsPkData'); if (!el) return;
  var D = JSON.parse(el.textContent), T = D.t;
  var root = el.closest('.fx-buy') || document;
  var form = document.getElementById('fspBuy');
  var q = root.querySelector('.fx-row .fx-qty input');
  var $ = function (s) { return root.querySelector(s); };
  var fmt = function (c) { return (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var m2 = function (g) { return String(g * 0.5).replace('.', ','); };
  var procs = D.procs.filter(function (p) { return p.ok && p.cap > 0; }).sort(function (a, b) { return a.cap - b.cap; });
  var accs = [].slice.call(root.querySelectorAll('.pk-ac')).map(function (li) { return { li: li, k: li.dataset.pkAcc, inp: li.querySelector('input') }; });

  function val(n) { var r = root.querySelector('input[name="' + n + '"]:checked'); return r ? r : null; }
  function proc(gab) {
    var px = gab * D.gpx, fit = procs.filter(function (p) { return px <= p.cap; });
    for (var i = 0; i < fit.length; i++) if (px / fit[i].cap <= 0.8) return fit[i];
    return fit.length ? fit[fit.length - 1] : null;
  }
  function sug(k, gab) {
    if (k === 'mod') return Math.max(5, Math.ceil(gab * D.mods * 0.07));
    if (k === 'pwr') return Math.ceil(gab / 8);
    if (k === 'rep') return 1;
    return 0;
  }
  function state() {
    var c = val('pk_case'), per = +c.dataset.n, n = Math.max(1, parseInt(q.value, 10) || 1); q.value = n;
    return { c: c, per: per, n: n, gab: per * n, pr: proc(per * n), wp: (val('pk_proc') || {}).value === 'y' };
  }
  function upd() {
    var s = state(), casePrice = +s.c.dataset.price, tot = s.n * casePrice;
    var sub = (s.n > 1 ? T.subs : T.sub).replace('%c', s.n).replace('%g', s.gab).replace('%m', m2(s.gab));
    var subm = T.subm.replace('%c', s.n).replace('%g', s.gab).replace('%m', m2(s.gab));
    root.querySelector('[data-pk-sub]').innerHTML = '<span class="pk-L">' + sub + '</span><span class="pk-S">' + subm + '</span>';
    var amt = $('.fx-price .fx-amt'); if (amt) amt.textContent = fmt(casePrice);
    var per = $('.fx-price [data-pk-per]'); if (per) per.textContent = T.per.replace('%n', s.per);
    // procesador
    var pimg = $('[data-pk-pimg]'), pr = s.pr;
    if (pr) {
      $('[data-pk-pname]').textContent = pr.n; $('[data-pk-pprice]').textContent = fmt(pr.price);
      $('[data-pk-pload]').textContent = T.load.replace('%p', Math.round(s.gab * D.gpx / pr.cap * 100));
      if (pimg.getAttribute('src') !== pr.img) { pimg.src = pr.img; pimg.alt = pr.n; }
    } else {
      $('[data-pk-pname]').textContent = T.over; $('[data-pk-pprice]').textContent = '—'; $('[data-pk-pload]').textContent = T.overs;
    }
    var wp = s.wp && !!pr;
    $('[data-pk-warn]').hidden = (val('pk_proc') || {}).value === 'y';
    if (wp) tot += pr.price;
    // accesorios
    var rows = [];
    accs.forEach(function (a) {
      var k = Math.max(0, parseInt(a.inp.value, 10) || 0); a.inp.value = k;
      var sg = sug(a.k, s.gab);
      a.li.querySelectorAll('[data-pk-sug]').forEach(function (b) { b.hidden = !sg; b.querySelector('b').textContent = sg; });
      a.li.classList.toggle('on', k > 0);
      if (k) { var p = k * +a.li.dataset.price; tot += p; rows.push('<div><span>' + k + ' × ' + a.li.dataset.name + '</span><span dir="ltr">' + fmt(p) + ' ' + D.cur + '</span></div>'); }
    });
    $('[data-pk-accn]').textContent = rows.length ? '· ' + rows.length : '';
    // resumen
    $('[data-pk-l1]').textContent = T.line.replace('%c', s.n).replace('%n', s.per).replace('%g', s.gab);
    $('[data-pk-p1]').textContent = fmt(s.n * casePrice) + ' ' + D.cur;
    $('[data-pk-rp]').hidden = !wp;
    if (pr) { $('[data-pk-l2]').textContent = pr.n; $('[data-pk-p2]').textContent = fmt(pr.price) + ' ' + D.cur; }
    var ra = $('[data-pk-ra]'); ra.hidden = !rows.length; ra.innerHTML = rows.join('');
    $('[data-pk-tot]').textContent = fmt(tot) + ' ' + D.cur;
    var mb = document.getElementById('fspMbP'); if (mb) mb.textContent = fmt(tot) + ' ' + D.cur + ' ' + T.deliv;
    var sb = document.querySelector('#fspSbar [data-sbar-price]'); if (sb) sb.textContent = fmt(tot) + ' ' + D.cur;
  }

  root.querySelectorAll('input[name="pk_case"],input[name="pk_proc"]').forEach(function (r) { r.addEventListener('change', upd); });
  q.addEventListener('input', upd);
  // los botones −/+ de la cantidad: se sustituyen los de fs-pdp-v64.js para recalcular (si no, sumaría 2)
  // se enlazan al terminar de cargar: fs-pdp-v64.js (diferido, más abajo en la página) les pone su propio onclick
  var bindQty = function () {
    var qb = q.parentElement.querySelectorAll('button');
    qb[0].onclick = function () { q.value = Math.max(1, (+q.value || 1) - 1); upd(); };
    qb[1].onclick = function () { q.value = (+q.value || 1) + 1; upd(); };
  };
  if (document.readyState === 'complete') bindQty(); else addEventListener('load', bindQty);
  accs.forEach(function (a) {
    var b = a.li.querySelectorAll('.pk-qty button');
    b[0].onclick = function () { a.inp.value = Math.max(0, (+a.inp.value || 0) - 1); upd(); };
    b[1].onclick = function () { a.inp.value = (+a.inp.value || 0) + 1; upd(); };
    a.inp.addEventListener('input', upd);
    a.li.querySelectorAll('[data-pk-sug]').forEach(function (s) { s.onclick = function () { a.inp.value = sug(a.k, state().gab); upd(); }; });
  });
  // carrusel: flechas físicas (la derecha avanza a la derecha, también en árabe) y ocultas en los extremos
  var tr = $('[data-pk-track]'), pv = $('.pk-prev'), nx = $('.pk-next');
  if (tr) {
    var rtl = getComputedStyle(tr).direction === 'rtl';
    var step = function () { var c = tr.querySelector('.pk-ac'); return c ? c.getBoundingClientRect().width + 10 : 200; };
    var ends = function () { var x = Math.abs(tr.scrollLeft), a = x <= 2, z = x + tr.clientWidth >= tr.scrollWidth - 2; pv.disabled = rtl ? z : a; nx.disabled = rtl ? a : z; };
    pv.onclick = function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); };
    nx.onclick = function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); };
    tr.addEventListener('scroll', ends, { passive: true });
    var det = root.querySelector('.pk-acc'); if (det) det.addEventListener('toggle', ends);
    ends();
  }
  // al comprar: línea 0 = flight case elegido (cantidad = nº de flight cases); después procesador y accesorios
  if (form) form.addEventListener('submit', function () {
    var s = state(), i = 1;
    form.querySelectorAll('.pk-x').forEach(function (x) { x.remove(); });
    var idIn = form.querySelector('input[name="items[0][id]"]'); if (idIn) idIn.value = s.c.value;
    var add = function (id, n) {
      [['id', id], ['quantity', n]].forEach(function (kv) { var x = document.createElement('input'); x.type = 'hidden'; x.className = 'pk-x'; x.name = 'items[' + i + '][' + kv[0] + ']'; x.value = kv[1]; form.appendChild(x); });
      i++;
    };
    if (s.wp && s.pr) add(s.pr.id, 1);
    accs.forEach(function (a) { var k = parseInt(a.inp.value, 10) || 0; if (k) add(a.li.dataset.id, k); });
  }, true);
  upd();
})();
